import React from 'react';
import PropTypes from 'prop-types';
import { WidgetSlider } from '../css';
import Slide from './Slide';
import ArrowButton from './ArrowButton';

const SliderDesktop = (props) => {
  const { news } = props;

  const settings = {
    infinite: news.length > 1,
    accessibility: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <ArrowButton direction="next" />,
    prevArrow: <ArrowButton direction="previous" />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="wrapper">
      <WidgetSlider {...settings}>
        {news.map((item, index) => (<Slide key={`slide-${index}`} {...item} />
        ))}
      </WidgetSlider>
    </div>
  );
};

SliderDesktop.propTypes = {
  news: PropTypes.array,
};

export default SliderDesktop;
